<template>
  <div v-if="canShowInstallBanner">
    <v-banner
      :color="bannerColor"
      class="text-left"
      dark
      icon="mdi-tablet-cellphone"
      rounded
      single-line
    >
      <span class="mx-2">{{ text }}</span>

      <template #actions>
        <v-btn
          v-if="showDismiss"
          text
          @click="onDismissClick"
        >
          Dismiss
        </v-btn>

        <v-btn
          :color="buttonColor"
          class=""
          depressed
          small
          @click="onInstallClick"
        >
          Install
        </v-btn>
      </template>
    </v-banner>
  </div>
</template>

<script>

import AppData from '@/mixins/appdata.js'
import {isDesktop, isMobile} from '@/lib/helper/helper.js'
import isDesktopApp from '@/desktop-app/isDesktopApp.js'
import axios from 'axios'
import yaml from 'js-yaml'

export default {
  name      : 'InstallAppBanner',
  components: {},
  directives: {},
  mixins    : [AppData],
  props     : {
    text: {
      type   : String,
      default: 'Install App on your device'
    },

    pwa: {
      type   : Boolean,
      default: false
    },

    electron: {
      type   : Boolean,
      default: false
    },

    showDismiss: {
      type   : Boolean,
      default: false
    },

    bannerColor: {
      type   : String,
      default: 'grey darken-4'
    },

    buttonColor: {
      type   : String,
      default: 'purple'
    }
  },
  data() {
    return {
      desktopApp    : null,
      deferredPrompt: null
    }
  },
  computed: {
    canShowInstallBanner() {
      return this.canShowPwaInstallBanner || this.canShowElectronInstallBanner
    },

    canShowPwaInstallBanner() {
      return this.pwa && !isDesktop() && !this.appIsPWA && !!this.deferredPrompt
    },

    canShowElectronInstallBanner() {
      return this.electron && !isMobile() && !isDesktopApp()
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
    this.addEvents()

    if (this.canShowElectronInstallBanner) {
      this.getLatestDesktopVersion()
    }
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
    this.removeEvents()
  },
  destroyed() {
  },
  methods: {
    async onBeforeInstallPrompt(e) {
      // const relatedApps = await navigator.getInstalledRelatedApps()
      e.preventDefault()
      this.deferredPrompt = e
    },

    async onAppInstalled() {
      this.deferredPrompt = null
    },

    onDismissClick() {
      this.deferredPrompt = null
    },

    async onInstallClick() {
      if (this.canShowPwaInstallBanner) {
        this.deferredPrompt.prompt()
        const {outcome} = await this.deferredPrompt.userChoice

        if (outcome === 'accepted') {
          // console.log('App was installed successfully.')
        } else {
          // console.log('App not installed! (Installation rejected by user.)')
        }

        this.deferredPrompt = null
      }

      if (this.canShowElectronInstallBanner) {
        const url = this.desktopApp && this.desktopApp?.path ? `https://gfp.ams3.digitaloceanspaces.com/releases/v3/latest/${this.desktopApp.path}` : 'https://help.getfoodpro.gr/el'
        const win = window.open(url, '_blank')
        if (win) win.focus()
      }
    },

    async getLatestDesktopVersion() {
      try {
        const yamlString = await axios.get('https://gfp.ams3.digitaloceanspaces.com/releases/v3/latest/latest.yml')
        this.desktopApp = yamlString?.data && yaml.load(yamlString?.data)
        // eslint-disable-next-line no-empty
      } catch (error) {
      }

      console.log('desktopApp: ', this.desktopApp)

      return this.desktopApp
    },

    addEvents() {
      this.removeEvents()
      window.addEventListener('beforeinstallprompt', this.onBeforeInstallPrompt)
      window.addEventListener('appinstalled', this.onAppInstalled)
    },

    removeEvents() {
      window.removeEventListener('beforeinstallprompt', this.onBeforeInstallPrompt)
      window.removeEventListener('appinstalled', this.onAppInstalled)
    }
  }
}
</script>

<style scoped>
:deep(.v-banner__wrapper) {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

:deep(.v-banner__icon) {
  margin-right: 4px !important;
}
</style>
